import { useEffect } from 'react';
import { Layer, WebMap } from '../constructors';

export const useSetMapLayersVisibility = (
    webMap: WebMap | undefined,
    displayedLayers: Layer[],
    visibleLayersIds: (string | number)[]
) => {
    useEffect(() => {
        displayedLayers
            ?.map((layer) => layer?.id)
            .forEach((layerId) => {
                const layer = webMap?.layers.find((layer) => layer?.id === layerId);
                const layerShouldBeVisible = visibleLayersIds.includes(layer?.id ?? '');
                const isLayerAlreadyWithCorrectVisibility =
                    (layerShouldBeVisible && layer?.visible) ||
                    (!layerShouldBeVisible && !layer?.visible);

                if (isLayerAlreadyWithCorrectVisibility || !layer) return;

                layer.visible = layerShouldBeVisible;
            });
    }, [webMap, visibleLayersIds, displayedLayers]);
};
